import { FormGroupDirective, NgForm, UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/**
 * Use this matcher if your form field should show errors even if it is not yet touched.
 */
export class AlwaysShowErrorMatcher implements ErrorStateMatcher {
  public isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control && control.invalid;
  }
}
